import { test as testConstants } from '@edulastic/constants'

const { calculators } = testConstants

const getCalcMap = () => {
  const calcMap = {}
  Object.keys(calculators).forEach((key) => {
    const { id, text } = calculators[key]
    calcMap[id] = { id, text }
    if (id.includes('GRAPHING')) {
      calcMap[id] = { id, text: 'GRAPHING' }
    }
    if (id.includes('SCIENTIFIC')) {
      calcMap[id] = { id, text: 'Scientific' }
    }
    if (id.includes('BASIC')) {
      calcMap[id] = { id, text: 'Basic' }
    }
  })
  return calcMap
}

export const CALC_MAP = getCalcMap()

export const DESMOS_GRAPHING_CALC_TYPES = [
  calculators.GRAPHING.id,
  calculators.GRAPHING_STATE.id,
  calculators.GRAPHING_CB.id,
  calculators.SCIENTIFIC_CB.id,
  calculators.BASIC_CB.id,
]

export const DESMOS_CALC_PROVIDER = 'DESMOS'
export const EDU_CALC_PROVIDER = 'EDULASTIC'
export const SCIENTIFIC_TYPE = 'SCIENTIFIC'

export const CALC_MODES = {
  BASIC_DESMOS: 'BASIC_DESMOS',
  BASIC_STATE_DESMOS: 'BASIC_STATE_DESMOS',
  BASIC_CB_DESMOS: 'BASIC_CB_DESMOS',
  SCIENTIFIC_DESMOS: 'SCIENTIFIC_DESMOS',
  SCIENTIFIC_STATE_DESMOS: 'SCIENTIFIC_STATE_DESMOS',
  SCIENTIFIC_CB_DESMOS: 'SCIENTIFIC_CB_DESMOS',
  GRAPHING_DESMOS: 'GRAPHING_DESMOS',
  GRAPHING_STATE_DESMOS: 'GRAPHING_STATE_DESMOS',
  GRAPHING_CB_DESMOS: 'GRAPHING_CB_DESMOS',
  BASIC_EDULASTIC: 'BASIC_EDULASTIC',
  SCIENTIFIC_EDULASTIC: 'SCIENTIFIC_EDULASTIC',
  GRAPHING_GEOGEBRASCIENTIFIC: 'GRAPHING_GEOGEBRASCIENTIFIC',
  SCIENTIFIC_GEOGEBRASCIENTIFIC: 'SCIENTIFIC_GEOGEBRASCIENTIFIC',
  MATRIX_DESMOS: 'MATRIX_DESMOS',
  MATRIX_EDULASTIC: 'MATRIX_EDULASTIC',
}

export const RND_PROPS = {
  defaultProps: { x: 0, y: 0, width: 350, height: 500 },
  [CALC_MODES.BASIC_DESMOS]: { x: 0, y: 0, width: 410, height: 500 },
  [CALC_MODES.BASIC_STATE_DESMOS]: { x: 0, y: 0, width: 410, height: 500 },
  [CALC_MODES.MATRIX_DESMOS]: { x: 0, y: 0, width: 600, height: 500 },
  [CALC_MODES.SCIENTIFIC_DESMOS]: { x: 0, y: 0, width: 600, height: 500 },
  [CALC_MODES.SCIENTIFIC_STATE_DESMOS]: { x: 0, y: 0, width: 600, height: 500 },
  [CALC_MODES.GRAPHING_DESMOS]: { x: 0, y: 0, width: 600, height: 400 },
  [CALC_MODES.GRAPHING_STATE_DESMOS]: { x: 0, y: 0, width: 600, height: 400 },
  [CALC_MODES.BASIC_CB_DESMOS]: { x: 0, y: 0, width: 410, height: 500 },
  [CALC_MODES.SCIENTIFIC_CB_DESMOS]: { x: 0, y: 0, width: 600, height: 500 },
  [CALC_MODES.GRAPHING_CB_DESMOS]: { x: 0, y: 0, width: 600, height: 400 },
  [CALC_MODES.MATRIX_EDULASTIC]: { x: 0, y: 0, width: 600, height: 500 },
  [CALC_MODES.BASIC_EDULASTIC]: { x: 0, y: 0, width: 350, height: 400 },
  [CALC_MODES.SCIENTIFIC_EDULASTIC]: { x: 0, y: 0, width: 500, height: 410 },
  [CALC_MODES.GRAPHING_GEOGEBRASCIENTIFIC]: {
    x: 0,
    y: 0,
    width: 800,
    height: 635,
  },
  [CALC_MODES.SCIENTIFIC_GEOGEBRASCIENTIFIC]: {
    x: 0,
    y: 0,
    width: 800,
    height: 635,
  },
}

export const GEOGEBRA_VERSION = '5.0'
